import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyCIK327qmoir8Gu4U0YgTNb3bSpYvIQ-yg",
    authDomain: "entertaiment-plus.firebaseapp.com",
    projectId: "entertaiment-plus",
    storageBucket: "entertaiment-plus.appspot.com",
    messagingSenderId: "75158894179",
    appId: "1:75158894179:web:7e0dc0df307534e4d02a56",
    measurementId: "G-XNG0BPWR6Z"
  };

  const firebaseApp  = firebase.initializeApp(firebaseConfig)
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage();

  export {auth, provider, storage};
  export default db;
